import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  employees: [],
  selectedEmployee: null,
};

const employeeSlice = createSlice({
  name: "companyEmployee",
  initialState,
  reducers: {
    // Get Employees
    getEmployeesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getEmployeesSuccess: (state, action) => {
      state.loading = false;
      state.employees = action.payload;
      state.error = null;
    },
    getEmployeesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Employee
    createEmployeeStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createEmployeeSuccess: (state, action) => {
      state.loading = false;
      state.employees.push(action.payload);
      state.error = null;
    },
    createEmployeeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Employee
    updateEmployeeStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateEmployeeSuccess: (state, action) => {
      state.loading = false;
      const index = state.employees.findIndex(
        (emp) => emp.id === action.payload.id
      );
      if (index !== -1) {
        state.employees[index] = action.payload;
      }
      state.error = null;
    },
    updateEmployeeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Employee
    setSelectedEmployee: (state, action) => {
      state.selectedEmployee = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getEmployeesStart,
  getEmployeesSuccess,
  getEmployeesFailure,
  createEmployeeStart,
  createEmployeeSuccess,
  createEmployeeFailure,
  updateEmployeeStart,
  updateEmployeeSuccess,
  updateEmployeeFailure,
  setSelectedEmployee,
  clearError,
} = employeeSlice.actions;

export default employeeSlice.reducer;
